<div [className]="statusClass" class="status">
    <span>{{'general.'+statusText | translate}}</span>
</div>